// Blobs live outside the JSON roadmap, so evidence does not consume its size limit.
function database(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("rovero-work-files", 1);
    request.onupgradeneeded = () => request.result.createObjectStore("files");
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
export async function storeDemoFile(file: File) {
  const db = await database(),
    key = crypto.randomUUID();
  try {
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction("files", "readwrite");
      tx.objectStore("files").put(file, key);
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(tx.error);
    });
    return `demo-work-file:${key}`;
  } finally {
    db.close();
  }
}
export async function readDemoFile(path: string): Promise<Blob> {
  const db = await database();
  try {
    return await new Promise((resolve, reject) => {
      const r = db
        .transaction("files")
        .objectStore("files")
        .get(path.replace("demo-work-file:", ""));
      r.onsuccess = () =>
        r.result
          ? resolve(r.result)
          : reject(new Error("Файл не найден в локальном хранилище"));
      r.onerror = () => reject(r.error);
    });
  } finally {
    db.close();
  }
}
